import script from "./sw-item-viewer-html.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-viewer-html.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-viewer-html.vue?vue&type=style&index=0&id=7016248a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7016248a"]])

export default __exports__